import { ca } from '@cian/analytics';

interface ITrackNewbuildingComparisonParams {
  entityId: number;
  label: string;
}

type TNewbuildingComparisonAction = 'Add' | 'Remove' | 'click_popup_add' | 'click_popup_remove';

function trackNewbuildingComparisonEvent(
  { entityId, label }: ITrackNewbuildingComparisonParams,
  action: TNewbuildingComparisonAction,
) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action,
    label,
    products: [
      {
        id: entityId,
        offerType: 'JK',
      },
    ],
  });
}

export function trackAddNewbuildingToComparison(params: ITrackNewbuildingComparisonParams) {
  trackNewbuildingComparisonEvent(params, 'Add');
}

export function trackDeleteNewbuildingFromComparison(params: ITrackNewbuildingComparisonParams) {
  trackNewbuildingComparisonEvent(params, 'Remove');
}

export function trackClickAddComparisonPopup(newbuildingId: number) {
  trackNewbuildingComparisonEvent({ entityId: newbuildingId, label: 'to_compare' }, 'click_popup_add');
}

export function trackClickRemoveComparisonPopup(newbuildingId: number) {
  trackNewbuildingComparisonEvent({ entityId: newbuildingId, label: 'to_compare' }, 'click_popup_remove');
}
